/*
 * TPS — masaüstü ürün görseli tam ekran galerisi <tps-lightbox> (owner, 2026-10-20).
 * Yalnız ≥990px (matchMedia); daha dar ekranda tıklama yok sayılır, açıkken daralırsa kapanır.
 * Galeriye (MediaGallery-<section>) tek delege dinleyici: görsel öğesine tıklanınca aynı media.id açılır.
 * Gezinme: ok butonları, ←/→, küçük resimler; kapatma: ×, Esc, arka plan. Komşu görseller ön-yüklenir.
 * Odak tuzağı/kaydırma kilidi temanın global yardımcıları (trapFocus, removeTrapFocus, setScrollbarWidth).
 */
if (!customElements.get('tps-lightbox')) {
  class TpsLightbox extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.mql = window.matchMedia('(min-width: 990px)');
      try {
        this.items = JSON.parse(this.querySelector('[data-tps-lightbox-items]').textContent);
      } catch (e) {
        this.items = [];
      }
      this.gallery = document.getElementById(this.dataset.gallery);
      if (!this.items.length || !this.gallery) return;

      this.dialog = this.querySelector('.tps-lightbox__dialog');
      this.img = this.querySelector('.tps-lightbox__img');
      this.current = this.querySelector('[data-current]');
      this.thumbList = this.querySelector('.tps-lightbox__thumbs');
      this.thumbs = Array.from(this.querySelectorAll('.tps-lightbox__thumb'));
      this.index = 0;
      this.onKey = this.onKey.bind(this);

      this.gallery.addEventListener('click', this.onGalleryClick.bind(this));
      this.querySelector('.tps-lightbox__close').addEventListener('click', () => this.close());
      const prev = this.querySelector('.tps-lightbox__nav--prev');
      const next = this.querySelector('.tps-lightbox__nav--next');
      if (prev) prev.addEventListener('click', () => this.go(-1));
      if (next) next.addEventListener('click', () => this.go(1));
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.show(Number(t.dataset.index))));
      this.addEventListener('click', (e) => {
        if (e.target === this || e.target === this.dialog || e.target.classList.contains('tps-lightbox__stage')) this.close();
      });
      this.img.addEventListener('load', () => this.classList.remove('is-loading'));
      this.mql.addEventListener('change', (e) => {
        if (!e.matches && this.hasAttribute('open')) this.close();
      });

      const root = this.gallery.closest('.product');
      if (root) root.classList.add('product--tps-lightbox');
    }

    onGalleryClick(event) {
      if (!this.mql.matches) return;
      if (event.target.closest('a, button, deferred-media, product-model, .tps-gallery-dots')) return;
      const item = event.target.closest('.product__media-item');
      if (!item || !item.querySelector('.product__modal-opener--image')) return;
      const id = String(item.dataset.mediaId || '').split('-').pop();
      const index = this.items.findIndex((i) => i.id === id);
      if (index < 0) return;
      event.preventDefault();
      this.open(index, item);
    }

    open(index, opener) {
      this.opener = opener;
      this.hidden = false;
      this.setAttribute('open', '');
      if (typeof setScrollbarWidth === 'function') setScrollbarWidth();
      document.body.classList.add('overflow-hidden');
      this.show(index);
      document.addEventListener('keydown', this.onKey);
      if (typeof trapFocus === 'function') trapFocus(this, this.dialog);
      else this.dialog.focus();
    }

    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      this.hidden = true;
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', this.onKey);
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.opener);
      else if (this.opener) this.opener.focus();
    }

    show(index) {
      const n = this.items.length;
      this.index = ((index % n) + n) % n;
      const item = this.items[this.index];
      if (this.img.currentSrc !== item.src) this.classList.add('is-loading');
      this.img.sizes = '100vw';
      this.img.srcset = item.srcset;
      this.img.src = item.src;
      this.img.alt = item.alt || '';
      if (item.w && item.h) {
        this.img.width = item.w;
        this.img.height = item.h;
      }
      if (this.current) this.current.textContent = this.index + 1;
      this.thumbs.forEach((t, i) => {
        const active = i === this.index;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-current', active ? 'true' : 'false');
        if (active && this.thumbList) {
          this.thumbList.scrollTo({ left: t.offsetLeft - this.thumbList.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
        }
      });
      if (n > 1) {
        [this.index + 1, this.index - 1].forEach((j) => {
          const p = this.items[((j % n) + n) % n];
          const pre = new Image();
          pre.sizes = '100vw';
          pre.srcset = p.srcset;
          pre.src = p.src;
        });
      }
    }

    go(delta) {
      this.show(this.index + delta);
    }

    onKey(event) {
      if (event.key === 'Escape') this.close();
      else if (event.key === 'ArrowRight') this.go(1);
      else if (event.key === 'ArrowLeft') this.go(-1);
    }
  }

  customElements.define('tps-lightbox', TpsLightbox);
}
